import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronDown, ChevronUp, LogOut, User } from "lucide-react";

interface MenuBarProps {
  user: {
    email: string;
  };
}

export const MenuBar = ({ user }: MenuBarProps) => {
  // State for user settings dropdown
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);
  const navigate = useNavigate();
  // Toggle user dropdown
  const toggleUserDropdown = () => {
    setUserDropdownOpen(!userDropdownOpen);
  };

  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      {/* Top menu bar */}
      <header className="bg-slate-900 text-white shadow-sm h-16 flex items-center justify-between px-4 z-10">
        <span className="text-3xl">
          OMG<b>YES</b>: Admin Portal
        </span>
        {/* User dropdown in top-right */}
        <div className="ml-auto relative">
          <button
            className="flex items-center space-x-2 px-3 py-2 rounded-md hover:bg-slate-800 transition-colors"
            onClick={toggleUserDropdown}
          >
            <div className="bg-gray-200 rounded-full p-2">
              <User size={18} className="text-gray-600" />
            </div>
            <span className="font-medium">{user?.email}</span>
            {userDropdownOpen ? (
              <ChevronUp size={16} className="text-gray-600" />
            ) : (
              <ChevronDown size={16} className="text-gray-600" />
            )}
          </button>

          {/* User dropdown menu */}
          {userDropdownOpen && (
            <div className="right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 fixed">
              <div
                className="px-4 py-2 text-gray-700 hover:bg-gray-100 flex items-center"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/logout");
                }}
              >
                <LogOut size={16} className="mr-2" />
                Log out
              </div>
            </div>
          )}
        </div>
      </header>
    </div>
  );
};
